<script setup>
import {defineProps} from "vue";
import NextButton from "../NextButton.vue";

const {flowState} = defineProps(['visible', 'flowState']);

const sendRequest = () => {
    // Send data to Hubspot
    flowState.setHubspotStatus();

    // Move to confirmation step
    flowState.lastStep();
}

</script>

<template>
    <div v-if="visible">
        <div class="tab">
	        <div class="row my-4">
		        <h5 class="tab-title">Access the <strong>free</strong> business plan and forecasting model:</h5>
	        </div>
            <p class="small-text-bold mb-5">
                We will use the registered email to send your request:
                <span class="small-text-bold w-100 d-flex fw-normal pt-1 text-primary">{{ flowState.getEmailFromCookie() }}</span>
            </p>
	      </div>

        <div>
            <NextButton
                    :text="flowState.nextButtonText()"
                    :enabled="true"
                    @click="() => { sendRequest() }"
            />
        </div>
    </div>
</template>